module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/lipBalm@3x_becf42.png";